module.exports = __webpack_public_path__ + "fonts/NespressoLucas-LightItalic.ttf?v=c111ea380c3e1319f9f5f8a2f2747334";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-LightItalic.ttf
// module id = 658
// module chunks = 0